// src/Redux/selectors/cycleBotSelectors.js

export const selectCycleBot = (state) => state.cycleBot;

/* ════ HEALTH ════ */
export const selectCycleBotHealth        = (state) => state.cycleBot.health.data;
export const selectCycleBotHealthLoading = (state) => state.cycleBot.health.loading;
export const selectCycleBotHealthError   = (state) => state.cycleBot.health.error;
export const selectCycleBotIsOnline      = (state) => state.cycleBot.health.data?.status === "ok";

/* ════ CHAT ════ */
export const selectChatSession        = (state) => state.cycleBot.chatSession.data;
export const selectChatSessionId      = (state) => state.cycleBot.chatSession.data?.session_id;
export const selectChatLoading        = (state) => state.cycleBot.chatSession.loading;
export const selectChatError          = (state) => state.cycleBot.chatSession.error;
export const selectMessages           = (state) => state.cycleBot.messages;
export const selectIsTyping           = (state) => state.cycleBot.isTyping;
export const selectChatAlerts         = (state) => state.cycleBot.chatSession.data?.alerts || [];

export const selectDashboardData = (state) => {
  const d = state.cycleBot.chatSession.data;
  if (!d) return null;
  return {
    last_cycle:   d.last_cycle   ?? null,
    predictions:  d.predictions  ?? null,
    health_score: d.health_score ?? null,
    stats:        d.stats        ?? null,
    alerts:       d.alerts       ?? [],
  };
};

/* ════ JOURNAL ════ */
export const selectJournalSummary         = (state) => state.cycleBot.journalSummary.data;
export const selectJournalSummaryLoading  = (state) => state.cycleBot.journalSummary.loading;
export const selectJournalSummaryError    = (state) => state.cycleBot.journalSummary.error;

export const selectJournalAnalysis        = (state) => state.cycleBot.journalAnalysis.data;
export const selectJournalAnalysisLoading = (state) => state.cycleBot.journalAnalysis.loading;
export const selectJournalAnalysisError   = (state) => state.cycleBot.journalAnalysis.error;

export const selectJournalEntries         = (state) => state.cycleBot.journalEntries.data;
export const selectJournalEntriesLoading  = (state) => state.cycleBot.journalEntries.loading;
export const selectJournalEntriesError    = (state) => state.cycleBot.journalEntries.error;

export const selectLogResult  = (state) => state.cycleBot.logResult.data;
export const selectLogLoading = (state) => state.cycleBot.logResult.loading;
export const selectLogError   = (state) => state.cycleBot.logResult.error;

/* ════ FLOWS ════ */
export const selectFlowsList          = (state) => state.cycleBot.flowsList.data;
export const selectFlowsListLoading   = (state) => state.cycleBot.flowsList.loading;
export const selectFlowsListError     = (state) => state.cycleBot.flowsList.error;

export const selectFlowDetail         = (state) => state.cycleBot.flowDetail.data;
export const selectFlowDetailLoading  = (state) => state.cycleBot.flowDetail.loading;

export const selectFlowSession        = (state) => state.cycleBot.flowSession.data;
export const selectFlowSessionLoading = (state) => state.cycleBot.flowSession.loading;
export const selectFlowSessionError   = (state) => state.cycleBot.flowSession.error;

export const selectFlowReport         = (state) => state.cycleBot.flowReport.data;
export const selectFlowReportLoading  = (state) => state.cycleBot.flowReport.loading;
export const selectFlowReportError    = (state) => state.cycleBot.flowReport.error;

export const selectIsGeneratingReport = (s) => s.cycleBot?.isGeneratingReport ?? false;
export const selectIsFlowActive       = (state) => !!state.cycleBot.flowSession.data;
export const selectIsFlowCompleted    = (state) => !!state.cycleBot.flowReport.data;

/* ════ RAPPORT PRÉ-MENSTRUEL ════ */
export const selectPremenstrualReport        = (s) => s.cycleBot?.premenstrualReport?.data    ?? null;
export const selectPremenstrualReportLoading = (s) => s.cycleBot?.premenstrualReport?.loading ?? false;
export const selectPremenstrualReportError   = (s) => s.cycleBot?.premenstrualReport?.error   ?? null;

/* ════ RESET CYCLE + HISTORIQUE ════ */
export const selectCycleReset          = (s) => s.cycleBot?.cycleReset?.data    ?? null;
export const selectCycleResetLoading   = (s) => s.cycleBot?.cycleReset?.loading ?? false;
export const selectJournalHistory      = (s) => s.cycleBot?.journalHistory?.data ?? null;
export const selectJournalHistoryLoading = (s) => s.cycleBot?.journalHistory?.loading ?? false;